import { runtimeEnv } from "utils/runtimeEnv";

import { HttpService } from "./HttpService";
import { KyClient } from "./KyClient";

const headers = {
  "Content-Type": "application/json",
};

export const defaultHost = import.meta.env.VITE_FAKE_STORE_API_HOST;
export const mockoonHost = import.meta.env.VITE_MOCKOON_API_HOST;
export const inresiHost = runtimeEnv.VITE_INRESI_API_HOST();
export const inresiWebAppUrl = runtimeEnv.VITE_INRESI_WEBAPP_URL();
export const inresiCmsAppUrl = runtimeEnv.VITE_INRESI_CMS_APP_URL();

// Keep the default host export for backward compatibility
export const host = defaultHost;

export const createHttpService = (host = defaultHost) =>
  new HttpService(new KyClient({ prefixUrl: host, headers }));

export const httpService = createHttpService();

// Use Mockoon host for this specific instance
export const mockoonHttpService = createHttpService(mockoonHost);

// Use Inresi host for this specific instance
export const inresiHttpService = createHttpService(inresiHost);

export {
  InternalServerException,
  ResourceNotFoundException,
  VisitorNotFoundException,
} from "./exceptions";
export { AjaxError } from "./AjaxError";
